const isComplexEnough = value => {
  if (!value.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{10,}$/)) {
    return false;
  }
  return true;
};

export default isComplexEnough;